export enum EnumRoutePaths {
  HOME = '/home',
  DEFAULT = '/',
  NO_MATCH = '/*',
  PROMOTIONS = '/promotions',
  HELP_CENTER = '/helpCenter',
}
